import React from "react";
import {
  applestore,
  deliverymanimg,
  forwardiconimg,
  fromkitchen,
  order1,
  order2,
  order3,
  phonefood,
  playstore,
  readycook,
} from "../../utilities/images";
import { Link } from "react-router-dom";

function FoodSection() {
  return (
    <>
      <div className='section'>
        <div className='section-container'>
          <div className='section-container-top'>
            <h1>Why 9tro Food?</h1>
            <p>
              Discover what makes 9tro Eat the go-to platform for delicious
              meals, fast delivery, and chef-powered experiences you can trust.
            </p>
          </div>
          <div className='foodsection-container-middle'>
            <div className='fscmleft'>
              <img src={fromkitchen} alt='From Kitchen' className='fsmlimg' />
              <img
                src={deliverymanimg}
                alt='Delivery Man'
                className='fsmlimg1'
              />
            </div>
            <div className='fscmright'>
              <img src={phonefood} alt='Phone Food' className='fsmimg' />
            </div>
          </div>
        </div>
      </div>
      <div className='section'>
        <div className='section-container'>
          <div className='section-container-top'>
            <h1>How to Order in 3 Steps</h1>
            <p>
              Getting your favorite meal is quick and simple—just follow these
              steps.
            </p>
          </div>
          <div className='foodsection-container-middle'>
            <img src={order1} alt='Order Step 1' className='fcmimg' />
            <img src={order2} alt='Order Step 2' className='fcmimg' />
            <img src={order3} alt='Order Step 3' className='fcmimg' />
          </div>

          <div className='navbar-downloadspace3 fdownload'>
            <Link to='/' className='downloadlink3'>
              <img src={applestore} alt='Apple store' />
              <span>Apple store</span>
            </Link>
            <Link to='/' className='downloadlink3'>
              <img src={playstore} alt='Play store' />
              <span>Play store</span>
            </Link>
          </div>
        </div>
      </div>

      <div className='sectionearn'>
        <div className='sectionearn-container'>
          <div className='sectionearn-left'>
            <div className='sectionearn-title foodsectiontitle'>
              <h1>Ready to Cook and Earn?</h1>
              <p>
                Join our network of talented chefs and home cooks. Delight
                customers with your special recipes, earn money doing what you
                love, and grow your culinary brand—one meal at a time!
              </p>
              <Link to='/' className='foodsectiontitlebtn'>
                Apply to be a chef <img src={forwardiconimg} alt='Apply' />
              </Link>
            </div>
          </div>
          <div className='sectionearn-right'>
            <div className='headerimg'>
              <picture>
                <source srcSet={readycook} media='(max-width: 500px)' />
                <img src={readycook} alt='Responsive' />
              </picture>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default FoodSection;
